import React from "react";

function AuctionSearch({ searchData, setSearchData, placeholder }) {
  return (
    <>
      <span className="material-symbols-outlined primary ">search</span>
      <input
        className="browser-default input-field  "
        placeholder={placeholder}
        value={searchData}
        type="text"
        onChange={(e) => setSearchData(e.target.value.trim())}
      />
    </>
  );
}

export default AuctionSearch;
